
(function () {
    'use strict';

    var module = angular.module('cccu.photoUpload.services', []);

    /// Service Used to
    module.factory('photoUploadService', ['$log', '$http', '$q', 'apiConfig', function ($log, $http, $q, apiConfig) {

        var _photo = null;

        return {
            photo: _photo,
            submitPhoto: function () {

                // Check to see if the photo has been cropped and added to the service.
                // if it hasn't, then return a failed promise.
                // it's marked as recoverable so that we can then feed this back to the user to try again.
                if (this.photo === null) {
                    var deferred = $q.defer();
                    deferred.reject({
                        statusText: 'There was no photo to process, please click Change Photo to retry.',
                        recoverable: true
                    });
                    return deferred.promise;
                }

                // Upload to the photo using the web api layer.
                var data = new FormData();
                data.append('file', this.photo);

                return $http.post(apiConfig.getUrlRoot() + 'students/me/photo', data, { transformRequest: angular.identity, headers: { 'Content-Type': undefined } });
            }
        };
    }
    ]);
}());
